export const loadFont = async (
    name: string,
    src: string,
    descriptors?: FontFaceDescriptors
) => {
    try {
        document.fonts.add(
            await new FontFace(name, `url(${src})`, descriptors).load()
        );
    } catch (e) {
        throw new Error(`Font ${name} failed to load`);
    }
};
